module.exports = __webpack_public_path__ + "img/agentOperation_increment1.2a6c32f3.png";